import { Field, reduxForm } from "redux-form";

import { Form } from "@js/forms/components/form";
import { NumberField, SelectField, TextField } from "@js/forms/fields";
import { countrySelectOptions, enumToOptions } from "@js/utils";

import { StripeACHBankAccountTypesWithLabels } from "../../constants";
import type { CreateACHPaymentMethodPayload } from "../../types";

export const ACH_FORM_ID = "ACH_METHOD_FORM";

export type ACHMethodFormData = Omit<
  CreateACHPaymentMethodPayload,
  "currency" | "usage" | "type"
>;

export const ACHForm = reduxForm<ACHMethodFormData, unknown>({
  form: ACH_FORM_ID,
  enableReinitialize: true,
})(({ submit, submitting, error }) => (
  <Form onSubmit={submitting ? null : submit} error={error}>
    <Field
      className="form-line"
      id="country"
      name="country"
      component={SelectField}
      variant="standard"
      options={countrySelectOptions}
      label="Country"
      disabled={true} // ACH is only available in the US
    />
    <Field
      className="form-line"
      id="account_holder_type"
      name="account_holder_type"
      component={SelectField}
      variant="standard"
      options={enumToOptions(StripeACHBankAccountTypesWithLabels)}
      label="Account Type"
    />
    <Field
      className="form-line"
      variant="standard"
      id="account_holder_name"
      name="account_holder_name"
      component={TextField}
      label="Account Holder Name"
      size="small"
    />
    <Field
      className="form-line"
      variant="standard"
      id="routing_number"
      name="routing_number"
      component={NumberField}
      label="Routing Number"
      size="small"
      slotProps={{
        htmlInput: {
          allowNegative: false,
        },
      }}
    />
    <Field
      className="form-line"
      variant="standard"
      id="account_number"
      name="account_number"
      component={NumberField}
      label="Account Number"
      size="small"
      slotProps={{
        htmlInput: {
          allowNegative: false,
        },
      }}
    />
  </Form>
));
